<body>
    <div class="grid-overlay">
        <app-page-header>
          <button class="header-action-btn"><a routerLink="/my-portals">{{ 'changeTemplate.header.viewPortalsButton' | translate }}</a></button>
        </app-page-header>
        <div class="setting-data">
            <div class="content-thanks">
                
            <div class="second-headboard">
                <h1>{{ 'changeTemplate.title' | translate }}</h1>
                <!-- <img src="../../assets/icons/1234.png" alt="logo de Billcentrix"> -->
              
            </div>
            <img style="width: 350px;height: 260px;object-fit: cover;" src="../../assets/images/process.gif" alt="">
            <p>{{ 'changeTemplate.redirecting' | translate: {countdown: countdown} }}</p>
            <div class="gracias_text">
            <p>{{ 'changeTemplate.thankYou' | translate }}</p>
           </div>
           
        </div>
           </div>
            </div>
        
</body>
